<template>
  <vuex-table :fields="fields" table_store="autoinformer/campaigns/table">
    <template slot="name" slot-scope="{ item, index }">
      <router-link
        v-if="is_pbx_allow"
        :to="{
          name: 'autoinformer.campaign.tasks',
          params: { id: item.id, tutorial: need_show_tutorial }
        }"
      >
        <div
          :class="`${index == 0 && hint.id === 'name' ? 'tutorial-form--table hint' : ''}`"
          :title="hint.text"
        >
          {{ item.name || `ID ${item.id}` }}
        </div>
      </router-link>
      <template v-else>
        {{ item.name }}
      </template>
    </template>
    <template slot="active" slot-scope="{ item, index }">
      <div
        :class="`${index == 0 && hint.id === 'status' ? 'tutorial-form--table hint' : ''}`"
        :title="hint.text"
      >
        <switch-status :id="item.id" :key="item.id" :value="item" />
      </div>
    </template>

    <template slot="worktimes" slot-scope="{ item }">
      <work-time-list-collapse :format_day="true" :items="item.worktimes" />
    </template>

    <template slot="actions" slot-scope="{ item }">
      <table-dropdown>
        <router-link
          tag="span"
          class="dropdown-item-icon dropdown-item-icon--edit"
          :to="{ name: 'autoinformer.campaign.edit', params: { id: item.id } }"
        >
          {{ $t('shared.component.table.action.edit') }}
        </router-link>

        <!-- <router-link
          :to="get_link_detail_stat(item)"
          class="dropdown-item-icon dropdown-item-icon--stats"
        >
          {{ $t('autoinformer.campaign.table.action.show_detail_stat') }}
        </router-link> -->

        <span
          v-if="!item.active"
          class="dropdown-item-icon dropdown-item-icon--trash"
          @click="remove(item)"
        >
          {{ $t('shared.component.table.action.delete') }}
        </span>
      </table-dropdown>
    </template>
  </vuex-table>
</template>

<script>
  import SwitchStatus from './campaigns-editbale-status';
  import { CampaignsModalService } from '@autoinformer/modals/CampaignsModalService.js';
  import { mapActions } from 'vuex';
  import WorkTimeListCollapse from '@pbx/components/time-conditions/_fragments/worktime/list-collapse';

  export default {
    components: {
      SwitchStatus,
      WorkTimeListCollapse
    },
    props: {
      hint: { type: Object, default: () => {} },
      counter: {
        type: Number,
        default: 1
      }
    },
    data: () => ({
      need_show_tutorial: false
    }),
    created() {
      this.need_show_tutorial = !!this.$route.params?.tutorial;
      if (this.$route.params?.counter) {
        this.counter = this.$route.params?.counter;
      }
    },
    computed: {
      computed_class: function () {
        if (this.hint) {
          return this.hint?.id === 'name' ? 'hint' : '';
        } else {
          return '';
        }
      },
      is_pbx_allow: function () {
        return this.$permission.module_pbx_is_allowed;
      },
      fields() {
        return [
          {
            key: 'name',
            label: this.$t('autoinformer.campaign.field.name'),
            sortable: true,
            thStyle: { width: '200px' }
          },
          {
            key: 'active',
            label: this.$t('shared.component.table.field.status'),
            sortable: true,
            thStyle: { width: '100px' }
          },
          {
            key: 'progress',
            label: this.$t('autoinformer.campaign.field.progress'),
            sortable: true,
            formatter: (value) => `${value}%`,
            thStyle: { width: '100px' }
          },
          {
            key: 'call_limit',
            label: this.$t('autoinformer.campaign.field.calls_limit'),
            thStyle: { width: '130px' }
          },
          {
            key: 'callers',
            label: this.$t('autoinformer.campaign.field.caller_id'),
            formatter: (value) => (Array.isArray(value) ? value.join(', ') : value),
            thStyle: { width: '150px' }
          },
          {
            key: 'worktimes',
            label: this.$t('autoinformer.campaign.field.call_schedule'),
            thStyle: { width: '150px' }
          },
          {
            key: 'updated_at',
            label: this.$t('shared.component.table.field.updated_at'),
            sortable: true,
            thStyle: { width: '180px' }
          },
          {
            key: 'created_at',
            label: this.$t('shared.component.table.field.created_at'),
            sortable: true,
            thStyle: { width: '180px' }
          },
          {
            key: 'actions',
            label: this.$t('shared.component.table.actions'),
            sortable: false,
            class: 'text-center',
            thStyle: { width: '110px' }
          }
        ];
      }
    },
    methods: {
      ...mapActions('autoinformer/campaigns/table', ['getAsyncData']),

      remove(item) {
        CampaignsModalService.remove(item.id, item).on('success', () => {
          this.getAsyncData();
        });
      },

      get_link_detail_stat(item) {
        return {
          name: 'autoinformer.stats.type',
          params: { type: 'detailed' },
          query: { campaign_id: item.id }
        };
      }
    }
  };
</script>

<style lang="scss">
  .tutorial-form--table.hint {
    z-index: 100;
    padding: 4px 10px;
    background: #fff;
    border-radius: 2px;

    &:before {
      right: -77px;
      top: 30%;
    }

    &:after {
      top: 100%;
    }
  }
</style>
